const env = process.env.NODE_ENV
// var url = 'http://com.aojv.cj:16066';
var url = 'http://192.168.11.103:16066';
// var url = 'https://assetsuse.aojuai.com';
// var url2 = 'http://192.168.2.75:19091/interview';
var url2 = 'https://train.aojuai.com/interview'
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url, //线上 
    baseURL2 :url2 //线上 
  },
  production:{
     baseURL :'https://assetsuse.aojuai.com',
     baseURL2 :'https://train.aojuai.com/interview'
  }
}
export default {
  baseURL:config[env].baseURL,
  baseURL2:config[env].baseURL2
}